import { render, staticRenderFns } from "./AnamneseDetails.vue?vue&type=template&id=285888a6&scoped=true"
import script from "./AnamneseDetails.vue?vue&type=script&lang=js"
export * from "./AnamneseDetails.vue?vue&type=script&lang=js"
import style0 from "./AnamneseDetails.vue?vue&type=style&index=0&id=285888a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285888a6",
  null
  
)

export default component.exports